import { MainTabs } from "./pages/main/MainTabsPage";

export const App = ():JSX.Element => {
  return (
    <MainTabs />
  );
};

